const network = {
  namespaced: true,

  state: () => ({
    isOffline: typeof navigator !== "undefined" && navigator.onLine === false,
  }),

  getters: {
    isOffline: (state) => state.isOffline,
  },

  mutations: {
    SET_OFFLINE(state, val) {
      state.isOffline = val;
    },
  },

  actions: {
    setOnline({ commit }) {
      commit("SET_OFFLINE", false);
    },
    setOffline({ commit }) {
      commit("SET_OFFLINE", true);
    },
  },
};

export default network;
